export default __webpack_public_path__ + "static/media/logo138x75white.e8c65419.png";